<template>
  <activity-feed
    :extra-params="'?profile=' + this.$route.params.username"
    type="profile"
  />
</template>

<script>
import ActivityFeed from '@/components/feed/ActivityFeed'
import { mapState } from 'vuex'

export default {
  components: {
    ActivityFeed
  },
  computed: {
    ...mapState(['currentProfile']),
    currentProfile: function() {
      if (this.user) {
        console.log(this.user)
        return this.user.profile
      } else {
        return this.$store.state.currentProfile
      }
    },
    get_description: function() {
      if (this.currentProfile.profile.bio) {
        return this.currentProfile.profile.bio
      } else {
        return this.$t('meta.profile.index.description', {
          display_name: this.currentProfile.profile.display_name,
          username: this.currentProfile.username
        })
      }
    }
  },
  async asyncData({ store, params, error, payload }) {
    if (store.state.currentProfile.username == params.username) return
    if (payload) {
      store.commit('SET_CURRENT_PROFILE', payload)
    } else {
      if (params.username) {
        try {
          const res = await store.$api.getUserProfile(params.username)
          console.log(res)
          store.commit('SET_CURRENT_PROFILE', res)
        } catch (e) {
          error('This page is not found')
        }
      }
    }
  },
  head() {
    return {
      title: this.$t('meta.profile.index.title', {
        display_name: this.currentProfile.profile.display_name,
        username: this.currentProfile.username
      }),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.get_description
        },

        // Open Graph
        {
          hid: 'og:title',
          name: 'og:title',
          content:
            this.$t('meta.profile.index.title', {
              display_name: this.currentProfile.profile.display_name,
              username: this.currentProfile.username
            }) + ' | elementari.com'
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.get_description
        },
        {
          hid: 'og:image',
          name: 'og:image',
          content: this.currentProfile.profile.source
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: 'https://elementari.com' + this.$route.path
        }
      ]
    }
  },

  layout: 'profile'
}
</script>
